import _ from 'lodash'

import Vue from 'vue'
import Vuex from 'vuex'

import identity from '@/repository/identity'
import general from '@/repository/general'
import company from '@/repository/company'
import report from '@/repository/report'
import salesPoint from '@/repository/sales-point'
import enumeration from '@/repository/enumeration'
import geography from '@/repository/geography'
import reco from '@/repository/reco'

import { getEnvironment } from '@/model/environment'

Vue.use(Vuex)

const setModule = 'setApplicationModule'

const queueAlertAction = 'queueAlert'
const clearAlertsAction = 'clearAlerts'
const setAlerts = 'setAlerts'

const environment = {
  state: {
    current: getEnvironment(),
    applicationModule: undefined
  },
  actions: {
    [setModule]: (context, payload) => context.commit(setModule, payload)
  },
  mutations: {
    [setModule]: (state, payload) => { state.applicationModule = payload }
  }
}

const alert = {
  state: {
    queue: []
  },
  actions: {
    [queueAlertAction]: (context, payload) => context.commit(setAlerts, _.concat(context.state.queue, payload)),
    [clearAlertsAction]: (context) => context.commit(setAlerts, [])
  },
  mutations: {
    [setAlerts]: (state, payload) => { state.queue = payload }
  }
}

// TODO: move functions and module to dedicated files
export function setApplicationModule (store, appModule) {
  store.dispatch(setModule, appModule)
}

export function showAlert (store, alert) {
  store.dispatch(queueAlertAction, alert)
}

export function clearAlerts (store, alert) {
  store.dispatch(clearAlertsAction, alert)
}

export default new Vuex.Store({
  modules: {
    salesPoint,
    enumeration,
    identity,
    general,
    company,
    environment,
    alert,
    geography,
    reco,
    report
  }
})
